<template>
	<div class="tpl trend-detail-wrap">
		<mt-header title="详情" fixed>
			<router-link :to="{name:fromPath.name,query:{'selected':selected}}" slot="left">
				<mt-button icon="back"></mt-button>
			</router-link>
			<!--<mt-button class="add-friend-btn"  icon="more" slot="right"></mt-button>-->
		</mt-header>
		<div class="trend-content">
			<trend-content :uid="uid" :itemInfo="trendInfo" :itemImgs="trendInfo.attach" @deleteItem="deleteItem"></trend-content>
		</div>
		<div class="trend-options">
			<trend-option 
				:uid="uid" 
				:did="did" 
				:oid="trendInfo.uid"
				:nums="nums"
				@refreshData="getTrendContent"
				></trend-option>
		</div>
		
	</div>
</template>

<script>
	
	import TrendContent from "./TrendDetailContent"
	import TrendOption from "./TrendDetailOptions"
	export default{
		name:"trend-detail",
		components:{
			TrendContent,
			TrendOption,
		},
		data(){
			return{
				uid:"",
				did:"",				
				fromPath: "", //来源路由
				selected:"",
				trendInfo:"",
				nums:{}
			}
		},
		created(){
			this.uid = this.$store.state.UserId; //获取当前用户的id
			this.$store.commit("changeTabChoosed", "trends");
			this.$store.commit("changeTabBarShow", false);

			this.did = this.$route.query.id;
			this.selected = this.$route.query.selected;
			
			this.getTrendContent();
			
			
		},
		beforeRouteEnter(to, from, next) {
			next((vm) => { //参数vm就是当前组件的实例。
				vm.fromPath = from;
				console.log(vm.fromPath)
			})
		},
		methods:{
			getTrendContent(){
				this.$axios({
					url:"Dynamic/DynamicDetails",
					method:"post",
					data:{
						uid:this.uid,
						d_id:this.did
					}
				}).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.trendInfo = res.data.data;
						this.nums={
							rNum:this.trendInfo.reward,
							cNum:this.trendInfo.comment,
							gNum:this.trendInfo.good
						}
					}
				}).catch(err=>{
					console.log(err)
				})
			},
			deleteItem(data){
				console.log(data)
				if(data==200){
					this.$router.push({
						name:'trends',
						query:{'selected':this.selected}
					})
				}
			}
		}
	}
</script>

<style scoped>
	.trend-detail-wrap{
		padding-top: 2.5rem;
	}
	.trend-options{
		border-top: 0.5rem solid #f3f3f3;
	}
</style>


// WEBPACK FOOTER //
// src/components/Trends/TrendDetail.vue